export default __webpack_public_path__ + "static/wand-education_cover-big_1-f8d2e55202e9c94edd80fa3ced91ded4.webp";